// extracted by mini-css-extract-plugin
export default {"Wrapper":"AccreditationsActions_Wrapper__YAcuq"};